var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "cursor-pointer border-1 border-gray-300 rounded-md px-1",
    height: 44,
    width: 44,
    id: "svg10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 3,19 a 2,2 0 0 0 2,2 C 7,21 7,17 8,12 9,7 9,3 11,3 a 2,2 0 0 1 2,2",
    id: "path2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 5,12 h 6",
    id: "path4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 15,12 6,6",
    id: "path6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 15,18 6,-6",
    id: "path8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunction);
export default __webpack_public_path__ + "static/media/function.2a82a7979ca8f3e0357d40dd9b0480af.svg";
export { ForwardRef as ReactComponent };